import { DescriptionSlide } from "src/pods/conundrums/components/DescriptionSlide";
import { IntroSlide } from "src/pods/conundrums/components/IntroSlide";
import { OptionsSlide } from "src/pods/conundrums/components/OptionsSlide";
import { PairShareSlide } from "src/pods/conundrums/components/PairShareSlide";
import { ShareToStorySlide } from "src/pods/conundrums/components/ShareToStorySlide";
import { Slide } from "src/pods/conundrums/components/types";
import bruce from "src/pods/conundrums/assets/spaceStationBruce.png";
import spaceStationIntroImage from "src/pods/conundrums/assets/spaceStationIntro.png";
import katie from "src/pods/conundrums/assets/spaceStationKatie.png";
import mojo from "src/pods/conundrums/assets/spaceStationMojo.jpg";

const questionText = "Who should be the leader of the space station?";
const questionOptions = {
  mojo: {
    option: "Mojo",
    description: "Creative",
    icon: mojo,
  },
  katie: {
    option: "Katie",
    description: "Hard Worker",
    icon: katie,
  },
  bruce: {
    option: "Bruce",
    description: "Super Nice",
    icon: bruce,
  },
};
const slide2Options = [questionOptions.mojo, questionOptions.katie];
const slide3Options = [questionOptions.mojo, questionOptions.katie, questionOptions.bruce];
const senteceStarter = "_____ should be in charge because...";
const activities: Slide[] = [
  IntroSlide(
    "Space Station",
    "Mojo and friends are creating a space station, but they can't decide:",
    "Who should be in charge?",
    spaceStationIntroImage,
  ),
  DescriptionSlide(
    "Mojo and friends are creating a space station, and need to make a decision",
    spaceStationIntroImage,
  ),
  OptionsSlide(questionText, slide2Options, [questionOptions.bruce], senteceStarter),
  OptionsSlide(questionText, slide3Options, undefined, senteceStarter),
  PairShareSlide(
    "Did you like discussing with your classmates? Why?\nWas it hard? Why or why not?\nWhat else did you notice?",
  ),
  ShareToStorySlide(
    "Congrats on completing this Conundrum!",
    "Now that was an interesting question indeed.",
    "https://static.classdojo.com/img/spaceStationShare.png",
    "Great discussion!",
  ),
];

export default activities;
